import {Route} from '@angular/router';

import {TilegridViewComponent} from './tilegrid-view/tilegrid-view.component';
import {HomeViewComponent} from './home-view/home-view.component';
import {PagePath} from './page-path.model';
import {ReportViewComponent} from './report-view/report-view.component';
import {
  ALWAYS_TOP_DIMENSION_LEVEL_SERVICE,
  AlwaysTopDimensionLevelService,
  CHECK_NEXT_DIMENSION_LEVEL_SERVICE,
  CheckNextDimensionLevelService,
  dataServiceFactory,
  DIMENSION_LEVEL_SERVICE,
} from '@selpia/dimension-items/feature-tree-filters';

export const appRoutes: Route[] = [
  {path: '', component: HomeViewComponent},
  {
    path: PagePath.HotSpotsView,
    component: TilegridViewComponent,
    providers: [
      {provide: CHECK_NEXT_DIMENSION_LEVEL_SERVICE, useClass: CheckNextDimensionLevelService},
      {provide: DIMENSION_LEVEL_SERVICE, useFactory: dataServiceFactory},
    ],
  },
  {
    path: PagePath.ReportView,
    component: ReportViewComponent,
    providers: [
      {provide: ALWAYS_TOP_DIMENSION_LEVEL_SERVICE, useClass: AlwaysTopDimensionLevelService},
      {provide: DIMENSION_LEVEL_SERVICE, useFactory: dataServiceFactory},
    ],
  },
  {path: '**', redirectTo: '/'},
];
